import styled from 'styled-components'
import { get } from '../../utils/theme'

export const H6 = styled.h6`
  ${get('styles.h6')};
`
